import { createContext } from 'react';

import type { UTMAttrs } from '@shared/dream-components';

import type { PostCommunityComments } from '~/interfaces/post';

export interface PostPageContextType {
  postId: string;
  canShowCommentsNode: boolean;
  communityComments: PostCommunityComments | null;
  // Both false while the meta fetch is still pending on a publication with a community.
  showCommunityComments: boolean;
  showNativeComments: boolean;
  isGatedContentDisabled: boolean;
  onlyRenderComments: boolean;
  isPopupDisabled: boolean;
  hidePremiumComments: boolean;
  showRecommendedPostsNode: boolean;
  isSubscriberGateEnabled: boolean;
  isEmailCapturePopupEnabled: boolean;
  showSubscriberBreak: boolean;
  showPaywallBreak: boolean;
  showPaywallAndHidePostContent: boolean;
  showMeteredUsageBanner: boolean;
  isMeteredPaywallModalOpen: boolean;
  setIsMeteredPaywallModalOpen: (open: boolean) => void;
  showTextToSpeechBlock: boolean;
  paywallUrl?: string;
  utmParams?: UTMAttrs;
  forcePremium: boolean;
  enforcePaywallBreaks: boolean;
}

export const PostPageContext = createContext<PostPageContextType | undefined>(undefined);

// Shared by PostComments and its lazy-load skeleton so the skeleton reserves space exactly when comments render.
export const getCommentsVisibility = (context: PostPageContextType | undefined) => ({
  communityComments: context?.showCommunityComments ? context.communityComments : null,
  showNativeComments: Boolean(context?.showNativeComments),
});
